import React from "react";
import "./App.scss";

import Main from "./containers/Main";
function App() {
  return (
  
      <Main />
    
  );
}

export default App;
